<template>
  <div class="c-btn-wrapper">
    <span
      v-for="i in data.optionList"
      :key="i.id"
      :style="getStyle(i)"
      @click="handleClick(i)"
      :title="i.optionName"
      class="c-btn-wrapper-items textEllipsis">
      {{ i.optionName }}
    </span>
  </div>
</template>

<script>
  export default {
    props:{
      data:[Object]
    },
    data() {
      return {
      }
    },
    methods:{
      handleClick(i) {
        let isChoice = i.isDefault;
        if(this.data.isChoice===0) {  // 单选
          this.data.optionList.forEach(btn=>{
            btn.isDefault = 0;
          })
          if(isChoice) return;
        }
        i.isDefault = !i.isDefault;
        this.$emit("getBtnList",this.data.optionList)
      },
      getStyle(i) {
        let obj = { border:"", color: i.color,background:"" };
        if(i.isDefault) {
          obj.color = "#fff";
          obj.background = i.color?i.color:"#269D7B";
          obj.border = "none";
        }
        return obj;
      }
    }
  }
</script>

<style lang="less" scoped>
  .c-btn-wrapper {
    display: flex;
    align-items: center;
    height: 40px;
    &-items {
      display: inline-block;
      width: 56px;
      height: 22px;
      padding: 0 2px;
      box-sizing: border-box;
      line-height: 22px;
      text-align: center;
      border-radius: 4px;
      font-size: 12px;
      border:1px solid #E0E0E0;
      margin: 0 8px 0px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/attr/c-btn.vue